<template>
    <div class="readonlyBlockContainer" :class="edit ? 'readOnlyEdit' : ''">
        <template v-if="!edit">
            <div v-if="isExchange || valueObject.Info.SisData.CrohoName || valueObject.Info.SisData.CrohoCode || valueObject.Level || valueObject.ModeOfStudy || valueObject.Info.Duration || valueObject.Info.Credits || valueObject.Info.LanguageOfInstruction || valueObject.Info.StartMonth" class="itemReadonly">
                <div class="readonly-header" :class="[isReadMore ? 'itemOpen' : 'itemClose']" @click="toggleReadMore">
                    <h3>{{$t('programOverview.programmeDetails.label')}}</h3>
                    <ReadMoreButton :expanded="isReadMore" @toggle="toggleReadMore" />
                </div>
                <transition name="roll">
                    <div v-if="isReadMore" class="readonly-text-content">
                        <datadisplay v-if="isExchange" :data="valueObject.Faculties == null || valueObject.Faculties.length == 0 ? valueObject.Faculty : valueObject.Faculties.join(', ')" :label="$t('programOverview.programmeDetails.faculty')"></datadisplay>
                        <datadisplay :data="valueObject.Info.SisData.CrohoName" :label="$t('programOverview.programmeDetails.crohoname')"></datadisplay>
                        <datadisplay :data="valueObject.Info.SisData.CrohoCode" :label="$t('programOverview.programmeDetails.crohocode')"></datadisplay>
                        <datadisplay :data="valueObject.Level" :label="$t('programOverview.programmeDetails.level')"></datadisplay>
                        <datadisplay :data="valueObject.ModeOfStudy" :label="$t('programOverview.programmeDetails.modeOfStudy')"></datadisplay>
                        <datadisplay :data="valueObject.Info.Traject" :label="$t('programOverview.programmeDetails.track')"></datadisplay>
                        <datadisplay :data="valueObject.Info.Duration" :label="$t('programOverview.programmeDetails.duration')"></datadisplay>
                        <datadisplay :data="valueObject.Info.Credits" :label="$t('programOverview.programmeDetails.credits')"></datadisplay>
                        <datadisplay :data="valueObject.Info.LanguageOfInstruction" :label="$t('commonLabels.language')"></datadisplay>
                        <datadisplay :data="valueObject.Info.StartMonth" :label="$t('programOverview.programmeDetails.start')"></datadisplay>
                        <datadisplay v-if="isExchange" :data="valueObject.Info.LevelOfQualification == null ? loq : valueObject.Info.LevelOfQualification" :label="$t('programOverview.programmeDetails.levelOfQualification')"></datadisplay>
                    </div>
                </transition>
            </div>
        </template>
        <template v-else>
            <div class="readonly">
                <div class="left">
                    <h3>{{$t('programOverview.programmeDetails.label')}}</h3>
                </div>
                <div class="programDetailInfo">
                    <ExtraInfo id="ProgrammeDetails"></ExtraInfo>
                </div>
                <div class="clear"></div>
                <div class="is-gray-block data-clean">
                    <DataDisplayInBlock v-if="isExchange" infoKey="Faculties" :data="valueObject.Faculties == null || valueObject.Faculties.length == 0 ? valueObject.Faculty : valueObject.Faculties.join(', ')" :label="$t('programOverview.programmeDetails.faculty')"></DataDisplayInBlock>
                    <DataDisplayInBlock v-if="valueObject.Info.SisData.CrohoName" infoKey="Info.SisData.CrohoName" :data="valueObject.Info.SisData.CrohoName" :label="$t('programOverview.programmeDetails.crohoname')"></DataDisplayInBlock>
                    <DataDisplayInBlock v-if="valueObject.Info.SisData.CrohoCode" infoKey="Info.SisData.CrohoCode" :data="valueObject.Info.SisData.CrohoCode" :label="$t('programOverview.programmeDetails.crohocode')"></DataDisplayInBlock>
                    <DataDisplayInBlock v-if="valueObject.Level" infoKey="Level" :data="valueObject.Level" :label="$t('programOverview.programmeDetails.level')"></DataDisplayInBlock>
                    <DataDisplayInBlock v-if="valueObject.ModeOfStudy" infoKey="ModeOfStudy" :data="valueObject.ModeOfStudy" :label="$t('programOverview.programmeDetails.modeOfStudy')"></DataDisplayInBlock>
                    <DataDisplayInBlock v-if="valueObject.Info.Traject" infoKey="Info.Traject" :data="valueObject.Info.Traject" :label="$t('programOverview.programmeDetails.track')"></DataDisplayInBlock>
                    <DataDisplayInBlock v-if="valueObject.Info.Duration" infoKey="Info.Duration" :data="valueObject.Info.Duration" :label="$t('programOverview.programmeDetails.duration')"></DataDisplayInBlock>
                    <DataDisplayInBlock v-if="valueObject.Info.Credits" infoKey="Info.Credits" :data="valueObject.Info.Credits" :label="$t('programOverview.programmeDetails.credits')"></DataDisplayInBlock>
                    <DataDisplayInBlock v-if="valueObject.Info.LanguageOfInstruction" infoKey="Info.LanguageOfInstruction" :data="valueObject.Info.LanguageOfInstruction" :label="$t('commonLabels.language')"></DataDisplayInBlock>
                    <DataDisplayInBlock v-if="valueObject.Info.StartMonth" infoKey="Info.StartMonth" :data="valueObject.Info.StartMonth" :label="$t('programOverview.programmeDetails.start')"></DataDisplayInBlock>
                    <DataDisplayInBlock v-if="isExchange" infoKey="LevelOfQualification" :data="valueObject.Info.LevelOfQualification == null ? loq : valueObject.Info.LevelOfQualification" :label="$t('programOverview.programmeDetails.levelOfQualification')"></DataDisplayInBlock>                
                </div>
            </div>
        </template>
    </div>
</template>

<script>

import Item from "../../mixins/Item.js";
import Datadisplay from "common/components/General/Datadisplay.vue";
import DataDisplayInBlock from "./DataDisplayInBlock.vue";
import ExtraInfo from "./ExtraInfo";
import ReadMoreButton from "./ReadMoreButton.vue";

export default {
	name: "readOnlyBlock-item",
	mixins: [Item],
	components: {
        DataDisplayInBlock,
        Datadisplay,
        ExtraInfo,
        ReadMoreButton
	},
	props: {
		required: Boolean
	},
	data: function() {
		return {
			valueObject: "",
            isReadMore: false
		};
	},
	computed: {
	},
	created() {
		this.valueObject = this.value;
	},
	methods: {
		onSave() {
            this.valueObject = this.value;
        },
		toOriginal() {},
        toggleReadMore() {
            this.isReadMore = !this.isReadMore;
        }        
	}
};
</script>
<style lang="less" scoped>
@import "../../assets/item.less";
.readonly {
	.snippet("");
	&::before {
		content: "Read-only";
	}
}
    .left {
        float:left;
    }
    .container {
        padding: 5px;
    }
    .clear {
        clear:both;
    }

    .readonly-header h3,
    .readonly h3 {
        font-size: 16px;
        line-height: 24px;
        font-weight: 700;
        margin-bottom: 0px;
    }

    .readonly-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        transition: background-color 0.3s;
        cursor: pointer;
        user-select: none;
    }
    
    .readonly-header:hover,
    .readonly-header.itemOpen {
        background-color: #F2F1F8;
    }

    .readonly-text-content {
        padding: 0px 16px 24px 16px;
        background-color: #F2F1F8;        
    }

    .roll-enter-active,
    .roll-leave-active {
        transition: all 300ms ease;
    }

    .roll-enter,
    .roll-leave-to {
        opacity: 0;
        transform: translateY(-20px);
    }

    .data-title h3 {
        font-size: 16px;
        line-height: 24px;
        font-weight: 700;
        margin-bottom: 0px;
    }

    @media (max-width: 768px) {
        .data-title h3,
        .data-content div {
            font-size: 14px;
        }

        .text-content div,
        .readonly-header h3 {
            font-size: 14px;
        }
    }

    .readonly-text-content div:not(:last-of-type) .data-content div {
        margin-bottom: 24px;
    }
</style>
